// src/plugins/permissions.ts
// Permission enforcement. Each SDK hook asks `requirePermission(pluginId, perm)`
// before doing anything real. If the manifest didn't declare the permission,
// we throw PluginPermissionError — the host shows a kid-friendly toast.
import { PluginPermissionError } from './types';
import { getEntry } from './registry';
export function hasPermission(pluginId, perm) {
    const entry = getEntry(pluginId);
    if (!entry)
        return false;
    return entry.manifest.permissions.includes(perm);
}
export function requirePermission(pluginId, perm) {
    if (!hasPermission(pluginId, perm)) {
        throw new PluginPermissionError(pluginId, perm);
    }
}
/** Human-readable explanation of each permission — used by the install UI. */
export const PERMISSION_DESCRIPTIONS = {
    'read:reviews': 'See your reviews.',
    'write:reviews': 'Reply to your reviews or mark them read.',
    'read:disputes': 'See your disputes.',
    'write:disputes': 'Create new disputes on your behalf.',
    'call:ai': 'Ask the AI to write something (uses your AI budget).',
    'read:org': 'Read your workspace name and basic settings.',
    'ui:navigate': 'Move you to different pages inside the app.',
    'ui:toast': 'Show you a little message at the bottom of the screen.',
    'external:fetch': 'Talk to an outside service (like Google or Yelp).',
};
